import { render, staticRenderFns } from "./BadgeColor.vue?vue&type=template&id=9b9333ba&scoped=true"
import script from "./BadgeColor.vue?vue&type=script&lang=js"
export * from "./BadgeColor.vue?vue&type=script&lang=js"
import style0 from "./BadgeColor.vue?vue&type=style&index=0&id=9b9333ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9333ba",
  null
  
)

export default component.exports